module.exports = __webpack_public_path__ + "img/lekkerllama.eecadac1.png";